import { t } from 'i18next';

// Codes come from api/service/src/errors/{users,roles-permissions}.ts (resolveServiceAdminRoles).
export function getAdminRolesErrorMap() {
  return {
    USER_SERVICE_ADMIN_ORGANIZATION_NOT_ALLOWED: t('serviceAdminOrganizationNotAllowedErr'),
    USER_SERVICE_ADMIN_ROLES_CONFLICTING: t('serviceAdminRolesConflictingErr'),
    NOT_ALLOWED_TO_ASSIGN_ROLE: t('notAllowedToAssignRoleErr'),
  };
}
